import { useEffect, useRef, useState } from 'react'
import { Loader2, FileText } from 'lucide-react'

// Configure worker once at module level
let workerConfigured = false
async function ensureWorker() {
  if (workerConfigured) return
  const pdfjsLib = await import('pdfjs-dist')
  pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
  ).href
  workerConfigured = true
  return pdfjsLib
}

export function PdfThumbnail({ url, className }) {
  const canvasRef = useRef(null)
  const [state, setState] = useState('loading') // loading | done | error

  useEffect(() => {
    if (!url) return
    let cancelled = false

    async function render() {
      try {
        const pdfjsLib = await ensureWorker()
        const pdf = await pdfjsLib.getDocument({ url, withCredentials: false }).promise
        if (cancelled) return
        const page = await pdf.getPage(1)
        if (cancelled) return
        const viewport = page.getViewport({ scale: 2 })
        const canvas = canvasRef.current
        if (!canvas) return
        canvas.width = viewport.width
        canvas.height = viewport.height
        await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise
        if (!cancelled) setState('done')
      } catch {
        if (!cancelled) setState('error')
      }
    }

    setState('loading')
    render()
    return () => { cancelled = true }
  }, [url])

  return (
    <div className={`relative w-full h-full flex items-center justify-center bg-surface-raised ${className || ''}`}>
      {state === 'loading' && <Loader2 size={18} className="text-text-faint animate-spin" />}
      {state === 'error' && (
        <div className="flex flex-col items-center gap-1.5 text-text-faint">
          <FileText size={24} />
          <span className="text-[10px]">PDF</span>
        </div>
      )}
      <canvas
        ref={canvasRef}
        className="w-full h-full object-cover"
        style={{ display: state === 'done' ? 'block' : 'none' }}
      />
    </div>
  )
}
